export default __webpack_public_path__ + "static/media/sunbright.f763ff11.jpg";